
export const scrollIntoView = (dom) => {
    if (!dom) {
        return;
    }
    // dom.scrollIntoView({block: "center", behavior: "smooth"});
    dom.scrollIntoView({block: "center"}); // behavior: "smooth" doesn't work on Xpresso > Customize
};